import api from "../../../api/apibackend";
import Vue from "vue";
import {
	SET_BEST_SELLING,
	SET_TOP_BUYERS,
	SET_PURCHASES_VERIFY,
	SET_TOTAL_PAYMENT,
	SET_WEEK_SALES,
	SET_TOP_STORES,
} from "./mutations.type";
import {
	PURCHASES_VERIFY,
	GET_PURCHASES_VERIFY,
	GET_BEST_SELLING,
	GET_TOP_BUYERS,
	GET_TOTAL_PAYMENT,
	GET_WEEK_SALES,
	GET_TOP_STORES,
} from "./actions.type";
import { GET_PRODUCTS } from "../products/actions.type";
import { GET_TELEGRAM_USERS } from "../storeModule/actions.type";

const groupBy = function(xs, key) {
	return xs.reduce(function(rv, x) {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	}, {});
};

const staticDisplayRanges = (state) => {
	let today = new Date();
	let lastWeek = new Date();
	lastWeek.setDate(today.getDate() - 7);
	let monthStart = new Date();
	monthStart.setDate(1);
	let yearStart = new Date(`01/01/${today.getFullYear()}`);
	return {
		week: [lastWeek, today],
		month: [monthStart, today],
		year: [yearStart, today],
		custom: state.customRange,
	};
};

const state = {
	purchaseVerify: [],
	bestSelling: [],
	topBuyers: { telegram: [], web: [] },
	topStores: [],
	totalPayment: 0,
	salesDisplayMode: "week",
	customRange: [new Date(), new Date()],
	displayRanges: {
		week: "week",
		month: "month",
		year: "year",
		custom: "custom",
	},
	weekSales: [],
};

const getters = {
	purchaseVerify: (state) => state.purchaseVerify,
	bestSelling: (state) => state.bestSelling,
	topBuyers: (state) => state.topBuyers,
	topStores: (state) => state.topStores,
	totalPayment: (state) => state.totalPayment,
	weekSales: (state) => state.weekSales,
	salesDisplayMode: (state) => state.salesDisplayMode,
	displayRanges: (state) => state.displayRanges,
	customRange: (state) => state.customRange,
};

const mutations = {
	[SET_PURCHASES_VERIFY](state, purchases) {
		state.purchaseVerify = purchases;
	},
	[SET_BEST_SELLING](state, bestSelling) {
		state.bestSelling = bestSelling;
	},
	[SET_TOP_BUYERS](state, buyers) {
		state.topBuyers = buyers;
	},
	[SET_TOP_STORES](state, stores) {
		state.topStores = stores;
	},
	[SET_TOTAL_PAYMENT](state, pay) {
		state.totalPayment = pay;
	},
	[SET_WEEK_SALES](state, weekSales) {
		Vue.set(state, "weekSales", weekSales);
	},
	setRange(state, mode) {
		state.salesDisplayMode = mode;
	},
	setCustomRange(state, range) {
		Vue.set(state, 'customRange', range);
	}
};

const actions = {
	setCustomRange({commit}, range) {
		commit('setCustomRange', range)
	},
	async setDateRange({ commit, dispatch }, range) {
		commit("setRange", range);
		await dispatch("getWeekSales");
	},
	async [GET_PURCHASES_VERIFY]({ commit }) {
		try {
			const { data } = await api.get("bill");
			const result = data
				.sort((first, second) => {
					return new Date(first.updated_at) - new Date(second.updated_at);
				})
				.slice(-5)
				.reverse();

			commit(SET_PURCHASES_VERIFY, result);
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	async [GET_BEST_SELLING]({ commit, rootGetters, dispatch }) {
		try {
			const { data } = await api.get("mostselled");
			if (rootGetters.products.length === 0) {
				await dispatch(GET_PRODUCTS);
			}
			data.forEach((bestSelling) => {
				const productResult = rootGetters.products.find((product) => {
					return product.id === bestSelling.product_id;
				});
				bestSelling.product = productResult;
			});
			commit(SET_BEST_SELLING, data ? data : []);
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	async [GET_TOP_BUYERS]({ commit, rootGetters, dispatch }) {
		try {
			const { data } = await api.get("mostuser");
			if (
				rootGetters.telegramUsers.web.length === 0 ||
				rootGetters.telegramUsers.telegram.length === 0
			) {
				await dispatch(GET_TELEGRAM_USERS);
			}
			data.web.forEach((topBuyer) => {
				const clientResult = rootGetters.telegramUsers.web.find(
					(user) => user.id === topBuyer[0]
				);
				topBuyer.client = clientResult;
				topBuyer.total = topBuyer[1];
			});
			data.telegram.forEach((topBuyer) => {
				const clientResult = rootGetters.telegramUsers.telegram.find(
					(user) => user.id === topBuyer[0]
				);
				topBuyer.client = clientResult;
				topBuyer.total = topBuyer[1];
			});
			commit(SET_TOP_BUYERS, data);
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	async [GET_TOP_STORES]({ commit }) {
		try {
			const { data } = await api.get("store/top");

			commit(SET_TOP_STORES, data.top);
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	async [GET_TOTAL_PAYMENT]({ commit }) {
		try {
			const { data } = await api.get("profit");
			commit(SET_TOTAL_PAYMENT, data);
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
	async [GET_WEEK_SALES]({ commit, state }) {
		try {
			let [startDate, endDate] = staticDisplayRanges(state)[
				state.salesDisplayMode
			];
			const { data } = await api.get("weeklysales", {
				params: {
					start_date: startDate.toLocaleDateString("en-US"),
					end_date: endDate.toLocaleDateString("en-US"),
				},
			});
			commit(SET_WEEK_SALES, data ? data : []);
			return data;
		} catch (err) {
			Vue.notify({
				group: "loggedIn",
				type: "error",
				text: err.message,
			});
		}
	},
};

export default {
	state,
	getters,
	mutations,
	actions,
};
